import { render } from "./AttributeValuesList.vue?vue&type=template&id=a9d989de&scoped=true&ts=true"
import script from "./AttributeValuesList.vue?vue&type=script&lang=ts"
export * from "./AttributeValuesList.vue?vue&type=script&lang=ts"

import "./AttributeValuesList.vue?vue&type=style&index=0&id=a9d989de&scoped=true&lang=css"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d989de"]])

export default __exports__